import { Suspense, useEffect, useState } from "react";
import { Outlet, useLocation, useNavigationType } from "react-router-dom";
import { Helmet } from "react-helmet";

import Header from "../components/header/Header";
import Footer from "../components/footer/Footer";
import CookieConsent from "../components/cookieConsent/CookieConsent";
import AlternatesContext from "../components/header/AlternatesContext";

const Layout = (props) => {
  const [alternates, setAlternates] = useState(null);
  const { pathname, hash } = useLocation();
  const navigationType = useNavigationType();

  // Client-side navigation keeps the previous page's scroll, so start each new page at the top.
  // Back/forward (POP) and links to an anchor keep their own position.
  useEffect(() => {
    if (navigationType !== "POP" && !hash) {
      window.scrollTo(0, 0);
    }
  }, [pathname]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <AlternatesContext.Provider value={setAlternates}>
      <Helmet htmlAttributes={{ lang: props.lang }} />
      <Header lang={props.lang} alternates={alternates}/>
      <Suspense fallback={<div style={{ minHeight: "70vh" }} />}>
        <Outlet />
      </Suspense>
      <Footer lang={props.lang} alternates={alternates}/>
      <CookieConsent lang={props.lang}/>
    </AlternatesContext.Provider>
  )
};

export default Layout;
